import type { ReactElement } from "react";
import { DownloadLandingPageContext } from "@external/DownloadLandingPageContext";
import { DownloadLandingPageContent } from "@external/DownloadLandingPageContent";
import type { RuntimeContext } from "@shared/RuntimeContextProvider";
import { RuntimeContextProvider } from "@shared/RuntimeContextProvider";
import { Route, Routes } from "react-router-dom";

const Page = (): ReactElement => (
  <Routes>
    <Route
      element={
        <DownloadLandingPageContext>
          <DownloadLandingPageContent />
        </DownloadLandingPageContext>
      }
      path={"download"}
    />
  </Routes>
);

function DownloadLandingPage({ context = "Shell" }: { context?: RuntimeContext }): ReactElement {
  return (
    <RuntimeContextProvider auth={false}
      Component={Page}
      context={context}
    />
  );
}

export default DownloadLandingPage;